(ns ui.editor2.sidebar-slide
  (:require [ui.editor2.common :as common]
            [ui.editor2.defaults :as defaults]))

(defn panel
  [state]
  (let [slide (common/get-current-slide state)
        background-color (or (:slide/background-color slide)
                             "#000000")]
    ;; panel-grid-list
    (when slide
      [:div
       {:class ["flex" "flex-col" "gap-2" "w-full"]}
       [:div.flex.flex-col.gap-6
        [:div
         [:span
          {:class ["text-xs" "font-medium"]}
          "Slide Duration [ms]"]
         [:input.mt-2.max-w-full.w-full.bg-white.border-gray-900.rounded.text-gray-800.shadow-sm.focus:hover:border-gray-500.focus:shadow-md
          {:style {:background-color "oklch(0.21 0.034 264.665)"
                   :color "white"}
           :type "number"
           :name "Slide Duration"
           :placeholder "duration"
           :step "1"
           :min (:slide/min-duration defaults/defaults)
           :max (:slide/max-duration defaults/defaults)
           :value (:slide/duration slide)
           :on {:change [[:editor2/set-slide-duration!
                          (:slide/uuid slide)
                          :event/target.value-int]]}}]]

        [:div
         [:span
          {:class ["text-xs" "font-medium"]}
          "Slide Background Color"]
         [:input.mt-2
          {:type "color"
           :on {:input [[:editor2/set-background-color :event/target.value]]}
           :value background-color
           :class ["block"
                   "bg-white"
                   "px-1"
                   "outline"
                   "outline-1"
                   "outline-offset-1"
                   "outline-gray-300"
                   "placeholder:text-gray-400"
                   "focus:outline"
                   "focus:outline-2"
                   "focus:-outline-offset-2"
                   "focus:outline-indigo-600"
                   "sm:text-sm/6"]}]]]
       ])))
